import { j as s } from "../../../jsx-runtime-B6kdoens.js";
import { a as u } from "../../../index-CROKJrb5.js";
import { c as m, f as l } from "../../../create-component-CBAeEoQ6.js";
const p = m(
  "FooterSocial",
  l(
    ({ as: r, children: o, className: t, ...c }, e) => {
      const a = r || "div";
      return /* @__PURE__ */ s.jsx(
        a,
        {
          ref: e,
          className: u(
            "cur-order-2 cur-flex cur-w-full cur-flex-col cur-content-start cur-gap-2 md:cur-order-3 lg:cur-order-2 lg:cur-w-auto",
            t
          ),
          ...c,
          children: o
        }
      );
    }
  )
);
export {
  p as FooterSocial
};
//# sourceMappingURL=index.js.map
